import store from '#/store';

export default function addOnboardRequiredRuleToRouter(router) {
  // reroutes to user onboard if needed
  router.beforeEach((to, from, next) => {
    if (store.getters['user/userNeedsOnboard']) {
      next({ path: '/onboard' });
      return;
    }
    next();
  });
}
